import { IconSvg, IconSvgProps } from "./icon"

export default function Calendar(props: IconSvgProps) {
  return (
    <IconSvg {...props}>
      <path d="M4.929 6.214A1.286 1.286 0 0 0 3.643 7.5v11.571a1.286 1.286 0 0 0 1.286 1.286H19.07a1.286 1.286 0 0 0 1.286-1.286V7.5a1.286 1.286 0 0 0-1.286-1.286H16.5M3.643 11.357h16.714M7.5 3.643v5.143M16.5 3.643v5.143M7.5 6.214h6.429" />
    </IconSvg>
  )
}
